import { Component, ChangeDetectionStrategy } from '@angular/core';

import { CONTACT_EMAIL } from 'src/utils/constants/constant';

@Component({
    selector: 'app-inactive-platform',
    imports: [],
    templateUrl: './inactive-platform.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./inactive-platform.component.scss']
})
export class InactivePlatformComponent {
  corporateEmail = CONTACT_EMAIL;

}
